import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { difference, union } from 'lodash';

//components
import withLocalization from '../../../hoc/withLocalization';
import GenericList from '../../../components/GenericList/GenericList';
import GenericFilter from '../../../components/GenericList/GenericFilter';
import Button from '../../../components/CustomButton/CustomButton';
import Checkbox from '../../../components/CustomCheckbox/CustomCheckbox';

//elements
import LoadingSpinner from '../../../elements/LoadingSpinner';

//assets
import Delete from '../../../assets/img/deleting.svg';
import { confirmAlert } from 'react-confirm-alert';

const project_assignment_statuses = [
    { code: 'assigned', name: 'Assigned' },
    { code: 'unassigned', name: 'Unassigned' },
];

class UserProjectAssignForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                name: '',
                status: '',
            },
            appliedFilters: {
                name: '',
                status: '',
            },
            selectedProjectIds: [],
            currentPageUnassignedIds: [],
            currentPageProjects: [],
            assignedCount: 0,
            unassignedCount: 0,
            loading: false,
            reloadKey: Date.now(),
            page: 0,
            isPageAddedOrEdited: false,
        };
    }

    setFilter = (field, value) => {
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                [field]: value
            }
        }));
    };

    handlePageChange = (page, isPageAddedOrEdited) => {
        this.setState({ page, isPageAddedOrEdited });
    };

    onFilter = () => {
        this.setState(prevState => ({
            appliedFilters: { ...prevState.filters },
            reloadKey: Date.now(),
            selectedProjectIds: [],
            currentPageUnassignedIds: [],
            currentPageProjects: [],
            page: 0,
            isPageAddedOrEdited: false
        }));
    };

    updateStatusFilter = (status) => {
        const { appliedFilters } = this.state;
        const newStatus = appliedFilters.status === status ? '' : status;

        this.setState(prev => ({
            filters: { ...prev.filters, status: newStatus }
        }),
            this.onFilter);
    }

    componentDidMount() {
        this.loadData()
    }

    loadData = async () => {
        const { userStore, id } = this.props;
        const { assigned, unassigned } = await userStore.projectsForUserCount({ userId: id });
        this.setState({ assignedCount: assigned, unassignedCount: unassigned })

        if(this.props.updateProjectCount){
            this.props.updateProjectCount(assigned || 0);
        }
    }

    toggleProjectSelection = (id) => {
        this.setState(prevState => {
            const { selectedProjectIds } = prevState;
            const newIds = selectedProjectIds.includes(id)
                ? selectedProjectIds.filter(itemId => itemId !== id)
                : [...selectedProjectIds, id];

            return { selectedProjectIds: newIds };
        });
    }

    toggleSelectAll = () => {
        this.setState(prevState => {
            const { currentPageUnassignedIds, selectedProjectIds } = prevState;
            const allCurrentSelected = currentPageUnassignedIds.every(id => selectedProjectIds.includes(id));

            if (allCurrentSelected) {
                const newSelection = difference(selectedProjectIds, currentPageUnassignedIds);
                return { selectedProjectIds: newSelection };
            } else {
                const newSelection = union(selectedProjectIds, currentPageUnassignedIds);
                return { selectedProjectIds: newSelection };
            }
        });
    }

    fetchProjects = (params = {}) => {
        const { name, status } = this.state.appliedFilters;
        const { userStore } = this.props;
        const options = {
            name: name || '',
            assigned: status || 'all',
            page: params.page || 0,
            pagesize: params.pagesize,
            isNotPagination: params.isNotPagination || false,
        };

        return userStore.getProjectsForUser(this.props.id, options).then(response => {
            const list = response.rows || [];

            if (list.length > 0) {
                const unassignedIds = list.filter(p => !p.is_assigned).map(p => p.id);
                this.setState({ currentPageUnassignedIds: unassignedIds, currentPageProjects: list });
            }
            return response;
        });
    };

    assignSelectedProjects = async () => {
        const { userStore, commonStore, t, id } = this.props;
        const { selectedProjectIds } = this.state;

        if (selectedProjectIds.length === 0) return;

        this.setState({ loading: true });

        try {
            const projectIds = selectedProjectIds.join(',');
            await userStore.saveProjectMembers({ userId: id, MemberInProjects: projectIds });

            commonStore.addNotification(t('Saved'), null, 'success');
            this.setState({
                reloadKey: Date.now(),
                selectedProjectIds: [],
                currentPageUnassignedIds: [],
                currentPageProjects: [],
                loading: false,
                isPageAddedOrEdited: true
            }, () => this.loadData());

        } catch (err) {
            this.setState({ loading: false });
            commonStore.addNotification(err.message || t('Error assigning projects'), null, 'error');
        }
    };

    unassignProject = async (projectId) => {
        const { userStore, commonStore, t , id } = this.props;
        try {
            confirmAlert({
                title: `${t('Confirm')} ?`,
                message: t('Are you sure you want to remove this member from the project?'),
                buttons: [
                    {
                        label: t('Yes'),
                        onClick: async () => {
                            const res = await userStore.deleteProjectMember(projectId, id);
                            commonStore.addNotification(t(res.message) || t('Saved'), null, 'success');
                            this.setState({ reloadKey: Date.now(), isPageAddedOrEdited: true }, () => this.loadData());
                        },
                    },
                    {
                        label: t('No'),
                        onClick: () => { }
                    },
                ]
            })
           
        } catch (err) {
            commonStore.addNotification(err.message || t('Error unassigning project'), null, 'error');
        }
    };

    renderCheckboxCell = (row) => {
        const projectId = row.original.id;
        const isAssigned = !!row.original.is_assigned;
        const { selectedProjectIds } = this.state;
        const isSelected = selectedProjectIds.includes(projectId);

        return (
            <div className="d-flex align-items-center justify-content-center">
                {isAssigned ? (
                    <Button icon_sm fill onClick={() => this.unassignProject(projectId)} title={this.props.t('Unassign')}>
                        <img src={Delete} alt="delete" />
                    </Button>
                ) : (
                    <Checkbox
                        inlineBlock
                        isChecked={isSelected}
                        onChange={() => this.toggleProjectSelection(projectId)}
                        wrapperClassName="checkbox-position-fix"
                        labelClassName="ps-0"
                    />
                )}
            </div>
        );
    }

    render() {
        const { id, t } = this.props;
        const { filters, appliedFilters, loading, selectedProjectIds, currentPageUnassignedIds, assignedCount, unassignedCount } = this.state;

        if (!id) return <div />;
        if (loading) return <LoadingSpinner />;

        const isAllSelected = currentPageUnassignedIds.length > 0 &&
            currentPageUnassignedIds.every(id => selectedProjectIds.includes(id));

        const columns = [
            {
                Header: t('Project'),
                id: 'project_name',
                textAlign : 'start',
                accessor: 'project_name',
                isSortable: true,
                Cell: ({ row }) => (
                    <div className="text-start">
                        {row.original.project_name}
                        {row.original.is_favorite && <i className="fa fa-star text-warning ms-3" />}
                    </div>
                )
            },
            {
                Header: appliedFilters.status === 'assigned' ? t('Unassign') : appliedFilters.status === 'unassigned' ? t('Assign') : `${t('Assign')} / ${t('Unassign')}`,
                id: 'assigned',
                textAlign: 'center',
                accessor: 'id',
                Cell: (cellProps) => this.renderCheckboxCell(cellProps.row),
            },
        ];

        return (
            <div>
                <div className="table-list mb-3">
                <GenericList
                    key={this.state.reloadKey}
                    columns={columns}
                    stickyHeader
                    header={
                        <>
                            <Row className="align-items-center gx-2">
                                <Col xs={12} lg={8} xl={8}>
                                    <Row className="member_status__summary">
                                        <Col
                                           xs="auto"
                                            className="mt-2 mt-sm-0 d-flex justify-content-center justify-content-sm-start"
                                        >
                                            <div
                                                className="highlightedgreen" role="button"
                                                onClick={() => this.updateStatusFilter('assigned')}
                                                style={{
                                                    cursor: 'pointer',
                                                    opacity: appliedFilters.status === 'assigned' ? 0.4 : 1
                                                }}
                                            >
                                                {`${t('Assigned')} ${t('Projects')}`}: {assignedCount}
                                            </div>
                                        </Col>
                                        <Col
                                            xs="auto"
                                            className="mt-2 mt-sm-0 d-flex justify-content-center"
                                        >
                                            <div
                                                className="highlightedred" role="button"
                                                onClick={() => this.updateStatusFilter('unassigned')}
                                                style={{
                                                    cursor: 'pointer',
                                                    opacity: appliedFilters.status === 'unassigned' ? 0.4 : 1
                                                }}
                                            >
                                                {`${t('Unassigned')} ${t('Projects')}`}: {unassignedCount}
                                            </div>
                                        </Col>
                                        <Col
                                           xs="auto"
                                            className="mt-2 mt-sm-0 d-flex justify-content-center justify-content-sm-end"
                                        >
                                            <Checkbox
                                                inlineBlock
                                                isChecked={isAllSelected}
                                                onChange={this.toggleSelectAll}
                                                disabled={currentPageUnassignedIds.length === 0}
                                                label={t("Select All")}
                                            />
                                        </Col>
                                    </Row>
                                </Col>

                                <Col xs="auto" className="d-flex justify-content-center justify-content-lg-end mt-2 mt-lg-0">
                                    {selectedProjectIds.length > 0 && (
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip id="tooltip-assign">
                                                    {t('Assign')}
                                                </Tooltip>
                                            }
                                        >
                                            <Button
                                                onClick={this.assignSelectedProjects}
                                                title={t('Assign')}
                                                fill
                                            >
                                                {t('Assign')} ({selectedProjectIds.length})
                                            </Button>
                                        </OverlayTrigger>
                                    )}
                                </Col>
                            </Row>
                            <GenericFilter
                                filters={filters}
                                setFilter={(name, value) => this.setFilter(name, value)}
                                onFilter={() => this.onFilter()}
                                loading={loading}
                                hasStatusFilter={true}
                                statusOptions={project_assignment_statuses}
                                searchFilterPlaceholder={t('Search') + ' ' + t('Project')}
                            />
                        </>
                    }
                    requestData={(params) => this.fetchProjects(params)}
                    filters={this.state.appliedFilters}
                    page={this.state.page}
                    isPageAddedOrEdited={this.state.isPageAddedOrEdited}
                    handlePageChange={this.handlePageChange}
                    showPageSizeSelector
                    pageSizeListId="user_project_assign"
                />
                </div>
            </div>
        );
    }
}

export default inject('userStore', 'commonStore')(withLocalization(observer(UserProjectAssignForm)));